<template>
  <section>
    <h2 class="page-title-bar">
      <i class="ico ico-multi"></i>{{ $t('Label Firmware') }}
    </h2>
    <v-data-table
      item-key="id"
      :headers="labelFirmwareListHeaders"
      :items="labelFirmwareList"
      :hide-default-footer="true"
      :items-per-page="labelFirmwareList.length"
      fixed-header
      class="tbl-type01 mt-10 products"
      height="528"
    >
      <template slot="no-data">
        <p>
          {{ $t('No data available') }}
        </p>
      </template>
    </v-data-table>
    <label-firmware-uploader
      :btnDisabledFileUpload="btnDisabledFileUpload"
      v-on:initLabelFirmware="initLabelFirmware"
    />
  </section>
</template>

<script>
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus'

// Components
import LabelFirmwareUploader from '@/views/Firmware/modal/LabelFirmwareUploader'
// Mixins
import SelectedStoreWatcher from '@/mixins/SelectedStoreWatcher'

export default {
  mixins: [SelectedStoreWatcher],
  name: 'LabelFirmware',
  components: {
    LabelFirmwareUploader
  },
  data () {
    return {
      labelFirmwareListHeaders: [
        {
          text: '#',
          sortable: false,
          align: 'center',
          value: 'idx',
          width: '10%'
        },
        {
          text: this.$t('SYSTEM'),
          sortable: true,
          align: 'start',
          value: 'system',
          width: '15%'
        },
        {
          text: this.$t('LABEL TYPE'),
          sortable: true,
          align: 'start',
          value: 'tagType',
          width: '15%'
        },
        {
          text: this.$t('CUSTOMER TYPE'),
          sortable: true,
          align: 'start',
          value: 'customer',
          width: '15%'
        },
        {
          text: this.$t('CODE'),
          sortable: true,
          align: 'start',
          value: 'typecode',
          width: '12%'
        },
        {
          text: this.$t('VERSION'),
          sortable: true,
          align: 'start',
          value: 'fwVersion',
          width: '12%'
        },
        {
          text: this.$t('LAST UPDATED TIME'),
          sortable: true,
          align: 'start',
          value: 'lastModifiedDate'
        }
      ],
      labelFirmwareList: [],
      btnDisabledFileUpload: false
    }
  },
  computed: {},
  watch: {},
  mounted () {
    // Select the company or load data.
    EventBus.$emit('enableSelectedStores', true)
    this.initLabelFirmware()
    // Check what buttons are inaccessable
    this.$store.dispatch('auth/getDisabledBtn', '10100').then(disabled => {
      this.btnDisabledFileUpload = disabled
    })
  },
  methods: {
    // etc
    afterSelectedStoreUpdate () {
      this.initLabelFirmware()
    },
    async initLabelFirmware () {
      this.labelFirmwareList = this.convertLabelFirmwareList(
        await this.getLabelFirmwareList()
      )
    },
    convertLabelFirmwareList (labelFirmwareList) {
      return labelFirmwareList.map((labelFirmware, idx) => {
        labelFirmware.tagType = `${
          labelFirmware.tagType
        } ${labelFirmware.tagInch.replace(/p|P/g, '.')}″`
        labelFirmware.idx = idx + 1
        return labelFirmware
      })
    },
    // API
    getLabelFirmwareList () {
      const config = { params: {} }
      return this.$utils
        .callAxios(
          codes.requests.getLabelFirmware.method,
          codes.requests.getLabelFirmware.url,
          config
        )
        .then(res => {
          return res.data.registeredPakcage ? res.data.registeredPakcage : []
        })
        .catch(error => {
          console.debug(`Could not find label firmware. error: ${error}`)
        })
    }
  }
}
</script>

<style></style>
